import { useState } from "react";
import { Button, CircularProgress, DialogActions, DialogContent, MenuItem, TextField } from "@mui/material";
import { financeApi } from "../../../api/config";
import { getStore } from "../../../store/store";
import { showResponseDialog } from "../bankTransactionsActions";

type MonthEndAllocationDialogProps = {
    onClose: () => void;
};

const MONTHS = [
    { value: 1, label: "Janeiro" },
    { value: 2, label: "Fevereiro" },
    { value: 3, label: "Março" },
    { value: 4, label: "Abril" },
    { value: 5, label: "Maio" },
    { value: 6, label: "Junho" },
    { value: 7, label: "Julho" },
    { value: 8, label: "Agosto" },
    { value: 9, label: "Setembro" },
    { value: 10, label: "Outubro" },
    { value: 11, label: "Novembro" },
    { value: 12, label: "Dezembro" },
];

const currentYear = new Date().getFullYear();
const YEARS = [currentYear, currentYear - 1];

export const MonthEndAllocationDialog = ({ onClose }: MonthEndAllocationDialogProps) => {
    const [year, setYear] = useState<number>(currentYear);
    const [month, setMonth] = useState<number>(new Date().getMonth() + 1);
    const [isLoading, setIsLoading] = useState(false);
    const { notifications } = getStore();

    const handleSubmit = async () => {
        setIsLoading(true);

        try {
            const response = await financeApi.post("/ai-finance-endpoint/run-month-end-allocation", { year, month });

            showResponseDialog("Alocação de Fim de Mês", response.data);
        } catch (error: any) {
            notifications.setNotification({
                isOpen: true,
                message: error?.response?.data?.error || "Erro ao executar alocação de fim de mês",
                severity: "error",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <TextField
                    select
                    label="Ano"
                    value={year}
                    onChange={(e) => setYear(Number(e.target.value))}
                    fullWidth
                >
                    {YEARS.map((yearOption) => (
                        <MenuItem key={yearOption} value={yearOption}>
                            {yearOption}
                        </MenuItem>
                    ))}
                </TextField>
                <TextField
                    select
                    label="Mês"
                    value={month}
                    onChange={(e) => setMonth(Number(e.target.value))}
                    fullWidth
                >
                    {MONTHS.map((monthOption) => (
                        <MenuItem key={monthOption.value} value={monthOption.value}>
                            {monthOption.label}
                        </MenuItem>
                    ))}
                </TextField>
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={onClose}>
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} disabled={isLoading}>
                    {isLoading ? <CircularProgress color="inherit" size={24} /> : "Executar"}
                </Button>
            </DialogActions>
        </>
    );
};
